/* Powiadomienie po dodaniu produktu do koszyka. */
if (!customElements.get('cart-notification')) {
  class CartNotification extends HTMLElement {
    constructor() {
      super();
      this.card = this.querySelector('.cart-notification__card');
      this.image = this.querySelector('.cart-notification__image');
      this.name = this.querySelector('.cart-notification__name');
      this.meta = this.querySelector('.cart-notification__meta');
      this.gross = this.querySelector('.cart-notification__gross');
      this.net = this.querySelector('.cart-notification__net');
      this.timer = this.querySelector('.cart-notification__timer');
      this.vatDivisor = parseFloat(this.dataset.vatDivisor) || 1;
      this.moneyFormat = this.dataset.moneyFormat || '{{amount_with_comma_separator}} zł';
      this.duration = 6000;
      this.hideTimeout = null;
    }

    connectedCallback() {
      // Na stronie koszyka potwierdzenie jest zbędne.
      this.disabled = window.location.pathname === this.dataset.cartPath;

      this.onAdd = (evt) => {
        if (this.disabled || !evt.detail || !evt.detail.cart) return;
        this.render(evt.detail.cart, evt.detail.variantId);
      };
      document.addEventListener('on:cart:add', this.onAdd);
      document.addEventListener('on:line-item:change', this.onAdd);

      this.querySelector('.cart-notification__close').addEventListener('click', () => this.hide());
      this.querySelector('.cart-notification__continue').addEventListener('click', () => this.hide());
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      this.onKeydown = (evt) => { if (evt.key === 'Escape' && !this.hidden) this.hide(); };
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('on:cart:add', this.onAdd);
      document.removeEventListener('on:line-item:change', this.onAdd);
      document.removeEventListener('keydown', this.onKeydown);
    }

    formatMoney(cents) {
      const value = (cents || 0) / 100;
      const withComma = value.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const withDot = value.toFixed(2);
      const noDecimals = Math.round(value).toLocaleString('pl-PL');
      return this.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, withDot);
    }

    render(cart, variantId) {
      const item = (cart.items || []).find((line) => line.variant_id === variantId) || (cart.items || [])[0];
      if (!item) return;

      if (item.image) {
        const src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
        this.image.src = src;
        this.image.alt = item.product_title || '';
        this.image.hidden = false;
      } else {
        this.image.hidden = true;
      }

      this.name.textContent = item.product_title || item.title || '';

      const parts = [];
      if (item.variant_title && item.variant_title !== 'Default Title') parts.push(item.variant_title);
      parts.push(`${item.quantity} szt.`);
      this.meta.textContent = parts.join(' · ');

      const linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
      this.gross.textContent = this.formatMoney(linePrice);
      this.net.textContent = linePrice > 0
        ? `(${this.formatMoney(Math.round(linePrice / this.vatDivisor))} netto)`
        : '';

      this.show();
    }

    positionBelowHeader() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.style.removeProperty('--cn-top');
        return;
      }
      const parts = document.querySelectorAll('.shopify-section-group-header-group, store-header, header');
      let bottom = 0;
      parts.forEach((part) => {
        const edge = part.getBoundingClientRect().bottom;
        if (edge > bottom) bottom = edge;
      });
      this.style.setProperty('--cn-top', `${Math.max(12, Math.round(bottom) + 12)}px`);
    }

    show() {
      this.positionBelowHeader();
      this.hidden = false;
      // Wymuszenie reflow, żeby animacja zadziałała przy kolejnych dodaniach.
      void this.card.offsetWidth;
      this.classList.add('is-visible');
      this.restartTimer();
    }

    hide() {
      this.classList.remove('is-visible');
      clearTimeout(this.hideTimeout);
      const finish = () => { this.hidden = true; };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else setTimeout(finish, 300);
    }

    restartTimer() {
      clearTimeout(this.hideTimeout);
      this.timer.style.animation = 'none';
      void this.timer.offsetWidth;
      this.timer.style.animation = `cart-notification-timer ${this.duration}ms linear forwards`;
      this.hideTimeout = setTimeout(() => this.hide(), this.duration);
    }

    pause() {
      clearTimeout(this.hideTimeout);
      this.timer.style.animationPlayState = 'paused';
    }

    resume() {
      if (this.hidden) return;
      this.timer.style.animationPlayState = 'running';
      this.hideTimeout = setTimeout(() => this.hide(), 2500);
    }
  }

  customElements.define('cart-notification', CartNotification);
}
